/*
 * Katana — Shopify Inbox chat typography.
 * The Inbox chat widget renders inside (nested) shadow DOM, so it can't be
 * reached by theme CSS. This walks the widget's shadow roots and injects a
 * <style> that sets the brand font, keeping it consistent with the site.
 * Best-effort: re-runs for a while to catch the lazily-mounted chat window.
 */
(function () {
  'use strict';

  var FONT = "'Cormorant Garamond', 'Zen Old Mincho', 'Times New Roman', serif";
  var CSS = ':host, :host * { font-family: ' + FONT + ' !important; }';
  var HOSTS = 'inbox-online-store-chat, shopify-online-store-chat, [id^="shopify-chat"]';

  function injectInto(shadow) {
    if (!shadow || shadow.querySelector('style[data-katana-font]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-katana-font', '');
    style.textContent = CSS;
    shadow.appendChild(style);
  }

  function walk(node) {
    if (!node) return;
    if (node.shadowRoot) {
      injectInto(node.shadowRoot);
      node.shadowRoot.querySelectorAll('*').forEach(walk);
    }
  }

  function run() {
    document.querySelectorAll(HOSTS).forEach(walk);
  }

  var tries = 0;
  var iv = setInterval(function () {
    tries += 1;
    run();
    if (tries > 40) clearInterval(iv); // ~20s
  }, 500);

  run();
})();
